module.exports = {"410506001":"田村街道","410506002":"彰武街道","410506003":"文昌大道街道","410506004":"文明大道街道","410506005":"太行小区街道","410506006":"中州路街道","410506100":"龙泉镇","410506101":"马投涧镇","410506103":"善应镇","410506201":"东风乡","410506205":"马家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410506.json
// module id = 1690
// module chunks = 0